import React from 'react';
import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import AdminContainer from '../../Utility/AdminContainer';
import useApiKey from '../../../Hooks/useApiKey';
import AdminBox from '../../Utility/AdminBox';
import { Prompt } from '../../../Types';
import AdminViewCard from '../../Utility/AdminViewCard';
import AdminBoxHeadline from '../../Utility/AdminBoxHeadline';
import { PaginationListType } from '../../../Types/PaginationParams';
import { promptService } from '../../../Services/promptService';
import PaginatedView from '../../Utility/PaginatedView';

function ApiKey() {
    const {
        ApiKeyActions,
        name,
        value,
        maxCosts,
        selectedPromptIdentifiers,
        apiKeyLoaded,
        apiKeyIdentifier,
        i18n,
        apiKeySnapshot,
    } = useApiKey();

    const handleSave = () => {
        ApiKeyActions.handleSave(name, maxCosts, apiKeyIdentifier || '');
    };

    const handleMaxCostChange = (value: number) => {
        ApiKeyActions.handleMaxCostChange(value);
    };

    const handleNameChange = (value: string) => {
        ApiKeyActions.handleNameChange(value);
    };

    const handlePromptCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        ApiKeyActions.handlePromptCheckboxChange(event);
    };

    const handleApiKeyChange = () => {};

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox contentLoaded={apiKeyLoaded}>
                    <>
                        <div className="w-full flex gap-8 flex-col">
                            <AdminBoxHeadline
                                headLine={i18n.translate({
                                    id: apiKeyIdentifier === 'new' ? 'newApiKey' : 'editApiKey',
                                    sourceName: 'ApiKey',
                                })}
                                subLine={apiKeyIdentifier === 'new' ? undefined : apiKeySnapshot?.name.toString()}
                            />

                            {apiKeyIdentifier !== 'new' && (
                                <div>
                                    <label htmlFor="apiKeyInput" className="block mb-2">
                                        {i18n.translate({ id: 'title.value', sourceName: 'ApiKey' })}
                                    </label>
                                    <Input
                                        inputType="text"
                                        disabled={true}
                                        value={value?.toString() ?? ''}
                                        onChange={handleApiKeyChange}
                                        id={'apiKeyInput'}
                                    />
                                </div>
                            )}

                            <div>
                                <label htmlFor="apiKeyNameInput" className="block mb-2">
                                    {i18n.translate({ id: 'title.name', sourceName: 'ApiKey' })}
                                </label>
                                <Input
                                    inputType="text"
                                    value={name?.toString() ?? ''}
                                    onChange={handleNameChange}
                                    id="apiKeyNameInput"
                                />
                            </div>

                            <div>
                                <label className="block mb-2" htmlFor="apiKeyCostsInput">
                                    {i18n.translate({ id: 'title.costsMonth', sourceName: 'ApiKey' })}
                                </label>
                                <Input
                                    inputType="number"
                                    value={maxCosts?.toString() ?? '0'}
                                    onChange={handleMaxCostChange}
                                    inputProps={{ min: 0, step: 0.1 }}
                                    id="apiKeyCostsInput"
                                />
                            </div>

                            <div>
                                <div className="mt-5">
                                    <PaginatedView
                                        listType={PaginationListType.Assistants}
                                        itemsFunction={promptService.getPromptsByPage}
                                        itemsPerPage={12}
                                        renderItem={(prompt: Prompt) => (
                                            <AdminViewCard
                                                key={prompt.identifier}
                                                identifier={prompt.identifier}
                                                title={prompt.name}
                                                image={prompt.image}
                                                useAvatar={true}
                                                handleChangeFunction={() =>
                                                    handlePromptCheckboxChange({
                                                        target: {
                                                            checked: !selectedPromptIdentifiers.includes(
                                                                prompt.identifier,
                                                            ),
                                                            name: prompt.identifier,
                                                        },
                                                    } as React.ChangeEvent<HTMLInputElement>)
                                                }
                                                isActive={selectedPromptIdentifiers.includes(prompt.identifier)}
                                            />
                                        )}
                                        filterClassName="mb-6"
                                        listClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 2xl:grid-cols-4 gap-4"
                                    >
                                        {({ list, filter }) => (
                                            <>
                                                <h5 className="mb-4">
                                                    {i18n.translate({ id: 'title.prompts', sourceName: 'ApiKey' })}
                                                </h5>

                                                {filter}
                                                {list}
                                            </>
                                        )}
                                    </PaginatedView>
                                </div>
                            </div>
                        </div>
                        <div className="mt-5 text-right">
                            <Button variant="primary" onClick={handleSave}>
                                {i18n.translate({ id: 'save', sourceName: 'Main' })}
                            </Button>
                        </div>
                    </>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default ApiKey;
